import { render, staticRenderFns } from "./OrganisationsRecord.vue?vue&type=template&id=818737f4&scoped=true"
import script from "./OrganisationsRecord.vue?vue&type=script&lang=js"
export * from "./OrganisationsRecord.vue?vue&type=script&lang=js"
import style0 from "./OrganisationsRecord.vue?vue&type=style&index=0&id=818737f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818737f4",
  null
  
)

export default component.exports